// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3haMJ","content":"styles_content__5NEYS","selectAll":"styles_selectAll__3zt6Y"};